import * as jQuery from 'jquery';

import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-video-player',
	styleUrls: ['./video-player.component.css'],
	templateUrl: './video-player.component.html'
})
export class VideoPlayerComponent implements OnInit, OnDestroy {
	@Input() videoURL: string;
	@ViewChild('videoName', { static: true }) videoPlayer: any;
	@Input() videoButtonsPath: object;
	public defaultVideoBtns: any = {
		mute: './assets/images/muteicon.png',
		pause: './assets/images/pause.png',
		play: './assets/images/play.png',
		unmute: './assets/images/unmuteicon.png'
	};
	public isPaused: boolean;
	public isMuted: boolean;
	public selectedVideoSubscription: any;
	private videoElement: any;
	constructor(private renderer: Renderer2) {
		this.selectedVideoSubscription = EmitterService.get('PLAY_SELECTED_VIDEO').subscribe((creative) => {
			setTimeout(() => {
				if (creative && (creative.isVideoCreative || creative.videoURL)) {
					if (this.videoURL !== creative.creativeVideo) {
						jQuery(this.videoElement)[0].load();
						this.pauseVideo();
						this.muteVideo();
					} else {
						if (creative.isTelevision) {
							this.muteVideo();
						}
						this.playVideo();
					}
				} else if (creative.isTelevision) {
					jQuery(this.videoElement)[0].load();
					this.pauseVideo();
					this.muteVideo();
				}
			}, 0);
		});
	}

	ngOnInit(): void {
		this.videoElement = this.videoPlayer.nativeElement;
		this.enableAutoPlayOnFlag(true);
		this.muteVideo();
		// Listen to video ended event in the component
		this.renderer.listen(this.videoElement, 'ended', (event) => {
			this.isPaused = true;
		});
		if (this.videoButtonsPath) {
			this.defaultVideoBtns = this.videoButtonsPath;
		}
	}

	enableAutoPlayOnFlag(enable: boolean): void {
		if (this.videoElement && jQuery(this.videoElement)[0]) {
			jQuery(this.videoElement)[0].autoplay = enable;
			this.isPaused = false;
		}
	}

	muteVideo(): void {
		if (this.videoElement && jQuery(this.videoElement)[0]) {
			jQuery(this.videoElement)[0].muted = true;
			this.isMuted = true;
		}
	}

	unmuteVideo(): void {
		if (this.videoElement && jQuery(this.videoElement)[0]) {
			jQuery(this.videoElement)[0].muted = false;
			this.isMuted = false;
		}
	}

	pauseVideo(): void {
		if (this.videoElement && jQuery(this.videoElement)[0]) {
			jQuery(this.videoElement)[0].pause();
			this.isPaused = true;
		}
	}

	playVideo(): void {
		if (this.videoElement && jQuery(this.videoElement)[0]) {
			jQuery(this.videoElement)[0].play();
			this.isPaused = false;
		}
	}

	toggleVideoPlay(): void {
		this.isPaused ? this.playVideo() : this.pauseVideo();
	}

	toggleVideoMute(): void {
		this.isMuted ? this.unmuteVideo() : this.muteVideo();
	}

	ngOnDestroy(): void {
		if (this.selectedVideoSubscription) {
			this.selectedVideoSubscription.unsubscribe();
		}
	}
}
